import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const DashboardConfigurationPage = lazy(
  () => import('~/features/configuration/pages/dashboard-configuration-page'),
);

/**
 * Dashboard Configuration — `/configuration/dashboard`. Renders OUTSIDE the
 * Configuration Manager `manager` layout because it has its own page chrome
 * and doesn't use the Platform selector. Surfaces in the sidebar once the
 * matching screen row is added in Platform Administration (already seeded in
 * the MSW nav mock).
 */
export const Route = createFileRoute('/_authenticated/_tenant/configuration/dashboard')({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <DashboardConfigurationPage />
    </Suspense>
  ),
});
